import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { LanguageService } from 'src/app/common/services/language.service';
import { country } from 'src/app/common/enums/language';
import { UtilService } from 'src/app/util/util.service';
@Component({
  selector: 'app-language-changer',
  templateUrl: './language-changer.component.html',
  styleUrls: ['./language-changer.component.css']
})
export class LanguageChangerComponent implements OnInit {
  defaultLang:string;
  languagePresets = [
    {label: 'Bahasa', value: 'id_ID'},
    {label: 'English', value: 'en_US'}
  ];
  @Output() onLanguageChange = new EventEmitter();
  
  constructor(
    private _language: LanguageService,
    private _util: UtilService
  ) { }

  ngOnInit() {
    this.defaultLang = localStorage.getItem("language") || 'id_ID';
  }

  onLanguageChanged(event) {
    this._language.setLanguage(event);
    this._language.setAcceptLanguage(country[event]);
    this.onLanguageChange.emit(event);
    // Sending react payload on language change
    this._util.sendDatatoReact({
      action: 'pos_app_language_change',
      language: event
    });
  }

}
